"use strict";
exports.__esModule = true;
var url_helpers_1 = require("../helpers/url-helpers");
var compareHostNames = function (url1, url2) {
    if (!url1 || !url2) {
        return '';
    }
    if (url_helpers_1.isPattern(url1) && !url_helpers_1.containsProtocolDelimeter(url1)) {
        url1 = url_helpers_1.addProtocol(url1);
    }
    if (url_helpers_1.isPattern(url2) && !url_helpers_1.containsProtocolDelimeter(url2)) {
        url2 = url_helpers_1.addProtocol(url2);
    }
    url1 = url1.replace('*', 'a');
    url2 = url2.replace('*', 'a');
    if (url_helpers_1.getDomain(url1) !== url_helpers_1.getDomain(url2)) {
        return 'Домены URL и бренда должны совпадать';
    }
    return '';
};
exports["default"] = compareHostNames;
